export default {
  quoteText:
    "Life is like riding a bicycle. To keep your balance, you must keep moving",
  quoteBy: "Albert Einstein"
};
